// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggler__jJ5Kv {
  position: relative;
  cursor: pointer;
}

.iconArrowContainer__k8VWC {
  width: 10px;
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
}
@media (max-width: 850px) {
  .iconArrowContainer__k8VWC {
    right: 10px;
  }
}

.collapsedArrow__AXV0Y {
  transform: rotate(180deg);
}

.collapseChildrenContainer__T4TOv {
  border-bottom: 1px solid #414141;
  border-top: 1px solid #414141;
}

.filledCollapse__jPbQ2 {
  background-color: #1f1f1f;
}
.filledCollapse__jPbQ2 .collapseChildrenContainer__T4TOv {
  border-bottom: unset;
  border-top: unset;
}`, "",{"version":3,"sources":["webpack://./../src/pages/Root/components/Collapse/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,kBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;AAzEF;AA2EE;EAPF;IAQI,WAAA;EAxEF;AACF;;AA2EA;EACE,yBAAA;AAxEF;;AA2EA;EACE,gCAAA;EACA,6BAAA;AAxEF;;AA2EA;EACE,yBAAA;AAxEF;AA0EE;EACE,oBAAA;EACA,iBAAA;AAxEJ","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.toggler {\n  position: relative;\n  cursor: pointer;\n}\n\n.iconArrowContainer {\n  width: 10px;\n  position: absolute;\n  top: 50%;\n  right: 15px;\n  transform: translateY(-50%);\n\n  @media (max-width: 850px) {\n    right: 10px;\n  }\n}\n\n.collapsedArrow {\n  transform: rotate(180deg);\n}\n\n.collapseChildrenContainer {\n  border-bottom: 1px solid #414141;\n  border-top: 1px solid #414141;\n}\n\n.filledCollapse {\n  background-color: #1f1f1f;\n\n  .collapseChildrenContainer {\n    border-bottom: unset;\n    border-top: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toggler": `toggler__jJ5Kv`,
	"iconArrowContainer": `iconArrowContainer__k8VWC`,
	"collapsedArrow": `collapsedArrow__AXV0Y`,
	"collapseChildrenContainer": `collapseChildrenContainer__T4TOv`,
	"filledCollapse": `filledCollapse__jPbQ2`
};
module.exports = ___CSS_LOADER_EXPORT___;
